<template>
    <div :class="['spec-view', type]">
        <slot />
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: 'default',
        },
    },
    data() {
        return {};
    },
};
</script>
<style lang="scss">
.spec-view {
    display: table;
    width: 100%;
    font-size: 10.5pt;
    color: #000;
}
</style>
